module.exports = __webpack_public_path__ + "img/logo-inverse-200x34.215b746a.png";